import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: {} },
	sign: 'dafdsf'
}

// 分页查询仓库
export function getWarehouse (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpwarehouse/page',
		method: 'post',
		data: obj
	})
}

// 新增仓库
export function addWarehouse (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpwarehouse/add',
		method: 'post',
		data: obj
	})
}

// 修改仓库
export function editWarehouse (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpwarehouse/edit',
		method: 'post',
		data: obj
	})
}

// 根据id删除仓库
export function delWarehouse (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/drpwarehouse/remove/${data}`,
		method: 'post',
		data: obj
	})
}

// 获取全部仓库管理员信息
export function getWarehouseManager (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mgruser/all/keeper/list',
		method: 'get',
		params: obj
	})
}

// 分页查询计量单位
export function getDrpunit (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpunit/page',
		method: 'post',
		data: obj
	})
}

// 新增计量单位
export function addDrpunit (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpunit/add',
		method: 'post',
		data: obj
	})
}

// 修改计量单位
export function editDrpunit (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpunit/edit',
		method: 'post',
		data: obj
	})
}

// 根据id删除计量单位
export function delDrpunit (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/drpunit/remove/${data}`,
		method: 'post',
		data: obj
	})
}
export function getMaterial (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drppurchaseplan/page/material',
		method: 'post',
		data: obj
	})
}

// 分页获取仓库原料配置
export function getWarehouseMaterial (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drphousematerial/page',
		method: 'post',
		data: obj
	})
}

// 入库保存接口
export function saveWarehouseDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpintoinventory/add/save',
		method: 'post',
		data: obj
	})
}

// 入库编辑保存接口
export function editSaveWarehouseDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpintoinventory/edit/save',
		method: 'post',
		data: obj
	})
}

// 入库保存提交
export function addWarehouseDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpintoinventory/add/commit',
		method: 'post',
		data: obj
	})
}

// 入库编辑保存提交
export function editAddWarehouseDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpintoinventory/edit/commit',
		method: 'post',
		data: obj
	})
}

// 分页获取入库记录列表
export function getWarehouseList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpintoinventory/page',
		method: 'post',
		data: obj
	})
}

// 根据id删除入库记录
export function delIntoId (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/drpintoinventory/remove/${data}`,
		method: 'post',
		data: obj
	})
}

// 出库保存接口
export function saveOuthouseDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpoutinventory/add/save',
		method: 'post',
		data: obj
	})
}

// 出库编辑保存接口
export function editSaveOuthouseDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpoutinventory/edit/save',
		method: 'post',
		data: obj
	})
}

// 出库保存提交
export function addOuthouseDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpoutinventory/add/commit',
		method: 'post',
		data: obj
	})
}

// 出库编辑保存提交
export function editAddOuthouseDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpoutinventory/edit/commit',
		method: 'post',
		data: obj
	})
}

// 分页获取出库记录列表
export function getOuthouseList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpoutinventory/page',
		method: 'post',
		data: obj
	})
}

// 根据id删除出库记录
export function delOutId (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/drpoutinventory/remove/${data}`,
		method: 'post',
		data: obj
	})
}

// 仓库配置信息导入原材料以及复制仓库配置信息接口
export function importMaterial (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drphousematerial/lead/in/house/material',
		method: 'post',
		data: obj
	})
}

// 分页获取仓库库存信息（仓库详情）
export function getDepotmanagedetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpinventory/page',
		method: 'post',
		data: obj
	})
}

// 分页获取入库批次详情
export function getpicidetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpintodetail/page',
		method: 'post',
		data: obj
	})
}
// 设置最大最小库存
export function setkucun (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpinventory/set',
		method: 'post',
		data: obj
	})
}
// 分页获取盘点记录列表
export function getCheckinventory (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpcheckinventory/page',
		method: 'post',
		data: obj
	})
}

// 库存盘点保存
export function saveCheckinventory (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpcheckinventory/add/save',
		method: 'post',
		data: obj
	})
}

// 盘点保存提交
export function commitCheckinventory (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpcheckinventory/add/commit',
		method: 'post',
		data: obj
	})
}

// 删除盘点记录
export function delCheckId (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: `/api/v1/drpcheckinventory/remove/${data}`,
		method: 'post',
		data: obj
	})
}

// 盘点记录编辑保存
export function saveEditcheckinventory (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpcheckinventory/edit/save',
		method: 'post',
		data: obj
	})
}

// 盘点记录编辑保存
export function commitEditcheckinventory (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpcheckinventory/edit/commit',
		method: 'post',
		data: obj
	})
}

// 盘点差异分析表
export function getCheckdifferanalyse (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpcheckinventory/page/analyse/check/differ',
		method: 'post',
		data: obj
	})
}

// 餐次出库成本分析表
export function getCostanalysis (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpreport/interval/out/cost',
		method: 'post',
		data: obj
	})
}

// 出库获取原料多批次
export function getInventroymaterial (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpintodetail/list/inventroy/material',
		method: 'post',
		data: obj
	})
}

// 获取盘点库存原料
export function getCheckinventorymaterial (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpcheckinventory/list/check/inventory/material',
		method: 'post',
		data: obj
	})
}

// 根据仓库获取盘点单号接口
export function getCheckinventorymateriallist (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpcheckinventory/list/checkId',
		method: 'post',
		data: obj
	})
}

// 食堂月度采购明细表
export function getMonthcaigoudetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpreport/into/out/detail/report',
		method: 'post',
		data: obj
	})
}

// excel导入入库单
export function uploadRukuexcel (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpintoinventory/import/into/excel',
		method: 'post',
		data
	})
}

// 库存预警
export function getKucunyujing (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpreport/inventory/warning',
		method: 'post',
		data: obj
	})
}

// 过期预警
export function getGuoqiyujing (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpreport/expire/warning',
		method: 'post',
		data: obj
	})
}

// 分页查询采购库存导入记录
export function getImportrecord (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpimportrecord/page/import/record',
		method: 'post',
		data: obj
	})
}
// 设置仓库库存状态
export function setwarehousestatus (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: 'api/v1/drpwarehouse/change/status',
		method: 'post',
		data: obj
	})
}
// 获取所有仓库
export function getWarehouseData (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpwarehouse/all',
		method: 'post',
		data: obj
	})
}
// 设置仓库库存大小
export function setWarehouseSize (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drpinventory/set',
		method: 'post',
		data: obj
	})
}
// 库存导出
export function warehouseExcelExport (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/drp-excel-export/inventory',
		method: 'post',
		data: obj,
		responseType: 'blob'
	})
}
